module.exports = __webpack_public_path__ + "static/media/Itameren_ruokakolmio_pieni.13d3ac73.jpg";